import React, { useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import "../styles/components/OrderHistory.css";

const StripePortal = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const { isAuthenticated, getAccessTokenSilently, user } = useAuth0();
  const API_URL = process.env.REACT_APP_API_BASE_URL;

  const createPortalSession = async () => {
    try {
      setLoading(true);
      setError(null);
      setSuccess(false);

      if (!isAuthenticated) {
        throw new Error(
          "Du må være logget inn for å få tilgang til kundeportal"
        );
      }

      const accessToken = await getAccessTokenSilently();
      const userEmail = user?.email;

      if (!userEmail) {
        throw new Error("Kunne ikke hente e-postadresse");
      }

      const response = await fetch(`${API_URL}/portal-session-create`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "X-User-Email": userEmail,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP-feil! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.url) {
        // Redirect to Stripe portal
        window.location.href = data.url;
        setSuccess(true);
      } else {
        throw new Error("Ingen portal URL mottatt fra serveren");
      }
    } catch (err) {
      console.error("Feil ved oppretting av portal-sesjon:", err);
      setError(
        err.message || "Kunne ikke opprette portal-sesjon. Prøv igjen senere."
      );
    } finally {
      setLoading(false);
    }
  };

  if (!isAuthenticated) {
    return (
      <div className="stripe-portal">
        <h1>Stripe Kundeportal</h1>
        <div className="not-authenticated">
          <p>Du må være logget inn for å få tilgang til kundeportal.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="stripe-portal">
      <h1>Stripe Kundeportal. Oppdater betalingsmetode</h1>

      <div className="portal-content">
        <p>I Stripe Kundeportal kan du oppdatere betalingsmetode.</p>

        {error && (
          <div className="error">
            <p>{error}</p>
            <button onClick={() => setError(null)} className="dismiss-btn">
              Lukk
            </button>
          </div>
        )}

        {success && (
          <div className="success">
            <p>Omdirigerer til Stripe Kundeportal...</p>
          </div>
        )}

        <button
          onClick={createPortalSession}
          className="portal-btn"
          disabled={loading}
        >
          {loading ? "Laster..." : "Åpne Kundeportal"}
        </button>
      </div>
    </div>
  );
};

export default StripePortal;
